module.exports = __webpack_public_path__ + "img/Pista_03.4ad5bafa.png";